import { render, staticRenderFns } from "./RelatorioGestaoPcaFsp.vue?vue&type=template&id=28ddbd93"
import script from "./RelatorioGestaoPcaFsp.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaFsp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports